import { EnvironmentProviders, provideAppInitializer } from '@angular/core';

import { maintenanceModeInitializer } from './maintenance-mode-initializer';

export function provideMaintenanceModeInitializer(): EnvironmentProviders {
	return provideAppInitializer(() => {
		const initializerFn = maintenanceModeInitializer();
		return initializerFn();
	});
}
